import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaDice,
  FaHorse,
  FaHorseHead,
  FaRegEye,
  FaRocket,
  FaTrophy,
  FaUser,
} from "react-icons/fa";
import { BiCricketBall, BiFootball, BiSolidTennisBall } from "react-icons/bi";
import { ImSpades } from "react-icons/im";
import { PiMonitorPlay } from "react-icons/pi";
import "bootstrap/dist/css/bootstrap.min.css";
import "./sidebarmenue.css";
import LoginPopup from "../LoginPopup/LoginPopup";
import AccountStatus from "../AccountStatus/AccountStatus";
import { useAuth } from "../AuthContext";
import Helper from "../../helper";
import { useDispatch, useSelector } from "react-redux";
import { emptyUserInfo } from "../../redux/slice/userInfo/userInfoSlice";
import SignUp from "../SignUp/SignUp";
import Login from "../Login/Login";
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import { toast } from "react-toastify";
import UserAutoLogout from "../userAutoLogout";
import ExposureHeader from "../ExposureHeader/ExposureHeader";
import ScrollGames from "../ScrollGames/ScrollGames";

const SideBarMenue = () => {
  const navigate = useNavigate();
  const userInfo = Helper();
  const { logout } = useAuth();
  const betData = useSelector((state) => state.data);
  const dispatch = useDispatch();
  UserAutoLogout();
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showDeposit, setShowDeposit] = useState(false);
  const [showMyMarkets, setShowMyMarkets] = useState(false);
  const [showCricketList, setShowCricketList] = useState(false);
  const [showFootballList, setShowFootballList] = useState(false);
  const [showTennisList, setShowTennisList] = useState(false);
  const [showHorseRacingList, setShowHorseRacingList] = useState(false);
  const [showGrayHoundRacingList, setShowGrayHoundRacingList] = useState(false);
  const [showIndianCardGamesList, setShowIndianCardGamesList] = useState(false);
  const [showLoginModel, setShowLoginModel] = useState(false);
  const [showSignupModel, setShowSignupModel] = useState(false);
  const [showForgotModel, setShowForgotModel] = useState(false);
  const [whatsappNum, setWhatsAppNumber] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [balance, setBalance] = useState(0);
  const [exposure, setExposure] = useState(0);
  let balanceWithExp = balance - Math.abs(exposure);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 991);
      if (window.innerWidth > 991) {
        setShowMenu(true);
      } else {
        setShowMenu(false);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    console.log("userInfo", userInfo);
  }, [userInfo]);

  const handleLogout = () => {
    handleClose();
    logout();
  };

  const handleToggleMenu = () => {
    if (showOffcanvas) {
      setShowOffcanvas(false);
    }
    setShowMenu(!showMenu);
  };

  const handleUserClick = () => {
    if (showMenu) {
      setShowMenu(false);
    }
    setShowOffcanvas(true);
  };

  const handleClose = () => {
    setShowOffcanvas(false);
  };

  const handleLoginPopupClick = () => {
    setShowLoginPopup(true);
  };

  const handleLoginPopupClose = () => {
    setShowLoginPopup(false);
  };

  const handleDeposit = () => {
    setShowDeposit(true);
    navigate("/deposit");
  };

  const handleMyMarkets = () => {
    if (userInfo) {
      handleToggleMenu();
    } else {
      setShowMenu(false);
      setShowLoginModel(true);
    }
  };

  const handleAviator = () => {
    if (userInfo) {
      // CreateAndLaunchWCOCasino(`SPB`, `aviator`);
    } else {
      setShowMenu(false);
      setShowLoginModel(true);
    }
  };

  const handleCricketList = () => {
    if (userInfo) {
      handleToggleMenu();
    } else {
      setShowMenu(false);
      setShowLoginModel(true);
    }
  };

  const handleFootballList = () => {
    if (userInfo) {
      handleToggleMenu();
    } else {
      setShowMenu(false);
      setShowLoginModel(true);
    }
  };

  const handleTennisList = () => {
    if (userInfo) {
      handleToggleMenu();
    } else {
      setShowMenu(false);
      setShowLoginModel(true);
    }
  };

  const handleHorseRacingList = () => {
    if (userInfo) {
      // CreateAndLaunchWCOCasino(`BT`);
    } else {
      setShowMenu(false);
      setShowLoginModel(true);
    }
  };

  const handleGrayHoundRacingList = () => {
    if (userInfo) {
      // CreateAndLaunchWCOCasino(`BT`);
    } else {
      setShowMenu(false);
      setShowLoginModel(true);
    }
  };

  const handleIndianCardGamesList = () => {
    if (userInfo) {
      // CreateAndLaunchWCOCasino(`BT`);
    } else {
      setShowMenu(false);
      setShowLoginModel(true);
    }
  };
  function OpenEzugiLobby(casinoType) {
    handleToggleMenu();
    if (userInfo) {
      navigate("/all-games-lobby", { state: { activeCasino: casinoType } });
    } else {
      setShowMenu(false);
      setShowLoginModel(true);
    }
  }

  // ✅ ONLY SHOW SIDEBAR ON DESKTOP (not mobile)
  return !isMobile && !userInfo ? (
    <div className="sidebar-menus absolute top-[137px]">
      <div className="sidebar-bg">
        <div className="sidebar-content">
          <span className="w-full bg-[#27a6c3] text-white flex">
            Popular
            {/* <button className="sidebar-close text-black" onClick={handleToggleMenu}>
              ×
            </button> */}
          </span>
          <nav className="sidebar-nav">
            <Link to={"/"} className="" onClick={handleToggleMenu}>
              <div className="sidebar-link" style={{ color: "#045662" }}>
                <div className="sidebar-icon">
                  <span className="home-icon"></span>
                </div>
                Home
              </div>
              <hr className="sidebar-divider" />
            </Link>

            <Link to={"/inPlay"} onClick={handleToggleMenu} style={{ color: "#045662" }}>
              <div className="sidebar-link border-b-2 border-[#045662]">
                <div className="sidebar-icon">
                  <span className="dummy-icon-in-play"></span>
                </div>
                In-Play
              </div>
              <hr className="sidebar-divider" />
            </Link>

            <Link to={"/cricketlist"} onClick={handleToggleMenu} style={{ color: "#045662" }}>
              <div className="sidebar-link">
                <div className="sidebar-icon">
                  <span className="dummy-icon2"></span>
                </div>
                Cricket
              </div>
              <hr className="sidebar-divider" />
            </Link>

            <Link to={"/football-list"} onClick={handleToggleMenu} style={{ color: "#045662" }}>
              <div className="sidebar-link">
                <div className="sidebar-icon">
                  <span className="dummy-icon-soccer"></span>
                </div>
                Soccer
              </div>
              <hr className="sidebar-divider" />
            </Link>

            <Link to={"/tennislist"} onClick={handleToggleMenu} style={{ color: "#045662" }}>
              <div className="sidebar-link">
                <div className="sidebar-icon">
                  <span className="dummy-icon5"></span>
                </div>
                Tennis
              </div>
              <hr className="sidebar-divider" />
            </Link>

            <div className="sidebar-link">
              <div className="sidebar-icon">
                <span className="dummy-icon6"></span>
              </div>
              Horse
            </div>
            <hr className="sidebar-divider" />

            <div className="sidebar-link" style={{ color: "#045662" }}>
              <div className="sidebar-icon">
                <span className="dummy-icon7"></span>
              </div>
              Greyhound
            </div>
            <hr className="sidebar-divider" />

            <div className="sidebar-link">
              <div className="sidebar-icon"
              >
                <span className="dummy-icon8"></span>
              </div>
              Ludo Cricket
            </div>
            <hr className="sidebar-divider" />

            <div className="sidebar-link" style={{ color: "#045662" }}>
              <div className="sidebar-icon">
                <span className="dummy-icon8"></span>
              </div>
              Indian Poker
            </div>
            <hr className="sidebar-divider" />

            <div className="sidebar-link" style={{ color: "#045662" }}>
              <div className="sidebar-icon">
                <span className="dummy-icon9"></span>
              </div>
              Indian Poker II
            </div>
            <hr className="sidebar-divider" />

            <div className="sidebar-link" style={{ color: "#045662" }}>
              <div className="sidebar-icon">
                <img
                  className="avator-design dummy-icons"
                  src="https://radheexch.app/assets/images/aviator-icon.svg"
                />
              </div>
              Aviator
            </div>
            <hr className="sidebar-divider" />

            <div className="sidebar-link" style={{ color: "#045662" }}>
              <div className="sidebar-icon">
                <span className="dummy-icon8"></span>
              </div>
              AE SEXY
            </div>
            <hr className="sidebar-divider" />

            <div className="sidebar-link" style={{ color: "#045662" }}>
              <div className="sidebar-icon">
                <span className="dummy-icon12"></span>
              </div>
              Evolution
            </div>
            <hr className="sidebar-divider" />

            <div className="sidebar-link">
              <div className="sidebar-icon">
                <span className="dummy-icon8"></span>
              </div>
              Live Casino
            </div>
            <hr className="sidebar-divider" />

            <div className="sidebar-link" style={{ color: "#045662" }}>
              <div className="sidebar-icon">
                <span className="dummy-icon12"></span>
              </div>
              VIVO
            </div>
            <hr className="sidebar-divider" />

            <div className="sidebar-link" style={{ color: "#045662" }}>
              <div className="sidebar-icon">
                <span className="dummy-icon12"></span>
              </div>
              betgames
            </div>
            <hr className="sidebar-divider" />

            <div className="sidebar-link" style={{ color: "#045662" }}>
              <div className="sidebar-icon">
                <span className="dummy-icon8"></span>
              </div>
              Caino III
            </div>
            <hr className="sidebar-divider" />
          </nav>
        </div>
      </div>
    </div>
  ) : null;
};

export default SideBarMenue;
